<button mat-button (click)="goBack()" class="back-button">
  <mat-icon>arrow_back</mat-icon> Back
  </button>
<div class="forgot-password-container">
  <h2>Forgot Password</h2>

  <form (ngSubmit)="onSubmit()" #forgotPasswordForm="ngForm">
    <!-- Email -->
    <div class="form-group">
      <label for="email">Email</label>
      <input
        type="email"
        id="email"
        name="email"
        [(ngModel)]="email"
        required
        placeholder="Enter your email"
        class="form-control"
      />
    </div>

    <!-- New Password -->
    <div class="form-group">
      <label for="newPassword">New Password</label>
      <input
        type="password"
        id="newPassword"
        name="newPassword"
        [(ngModel)]="newPassword"
        required
        placeholder="Enter your new password"
        class="form-control"
      />
    </div>

    <!-- Confirm New Password -->
    <div class="form-group">
      <label for="confirmPassword">Confirm New Password</label>
      <input
        type="password"
        id="confirmPassword"
        name="confirmPassword"
        [(ngModel)]="confirmPassword"
        required
        placeholder="Confirm your new password"
        class="form-control"
      />
    </div>

    <!-- Submit Button -->
    <button
      type="submit"
      class="btn btn-primary"
      [disabled]="!forgotPasswordForm.valid">
      Reset Password
    </button>
  </form>
</div>
